import React, { useEffect, useState } from "react";
import styles from "./home.module.css";
import { Col, Row, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../Component/Header/Header";
import Notification from "../../Component/Notification/Notification";
import { useAuth } from "../../Context/AuthContext";
import { Helmet } from "react-helmet";
import moment from "moment";
import { GET_DASHBOARD_GRAPH, GET_DASHBOARD_TILES } from "../../APIs/BaseUrl";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import Moment from "react-moment";

const Dashboard = () => {
  const navigate = useNavigate();
  const { toggleNotification } = useAuth();

  const [tiles, setTiles] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");

        // Fetch tiles
        const tilesRes = await fetch(GET_DASHBOARD_TILES, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const tilesData = await tilesRes.json();
        setTiles(tilesData.data);

        // Fetch graph
        const graphRes = await fetch(GET_DASHBOARD_GRAPH, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const graphJson = await graphRes.json();
        setGraphData(graphJson.data || []);
      } catch (err) {
        // handle error
      }
      setLoading(false);
    };

    fetchDashboardData();
  }, []);

  return (
    <React.Fragment>
      <div className="right-aside">
        <Helmet>Dashboard</Helmet>
        <Row>
          <Col md={!toggleNotification ? 12 : 8} sm={12}>
            <Header />
            <div className={styles.head_sec}>
              <h6>Dashboard Overview</h6>
              {loading ? (
                <div>Loading...</div>
              ) : (
                <>
                  {/* Tiles Section */}
                  <Row className="mb-4">
                    <Col md={3} sm={6} xs={12}>
                      <Card className="mb-2">
                        <Card.Body>
                          <h5>Total Researches</h5>
                          <h2>{tiles?.totalResearches ?? 0}</h2>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <Card className="mb-2">
                        <Card.Body>
                          <h5>Total Applications</h5>
                          <h2>{tiles?.totalApplications ?? 0}</h2>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <Card className="mb-2">
                        <Card.Body>
                          <h5>Pending Applications</h5>
                          <h2>{tiles?.pendingApplications ?? 0}</h2>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={3} sm={6} xs={12}>
                      <Card className="mb-2">
                        <Card.Body>
                          <h5>Reviewed Applications</h5>
                          <h2>{tiles?.reviewedApplications ?? 0}</h2>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>

                  {/* Graph Section */}
                  <Card className="mb-4">
                    <Card.Body>
                      <h5>Applications Over Time</h5>
                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={graphData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            dataKey="_id"
                            tickFormatter={(date) =>
                              moment(date).format("MMM DD")
                            }
                          />
                          <YAxis allowDecimals={false} />
                          <Tooltip
                            labelFormatter={(date) =>
                              moment(date).format("YYYY-MM-DD")
                            }
                          />
                          <Bar dataKey="count" fill="#8884d8" />
                        </BarChart>
                      </ResponsiveContainer>
                    </Card.Body>
                  </Card>

                  {/* Recent Application Section */}
                  {tiles?.recentApplication && (
                    <Card>
                      <Card.Body>
                        <h5>Recent Application</h5>
                        <div>
                          <strong>Name:</strong>{" "}
                          {tiles.recentApplication.applicant_id?.name}
                        </div>
                        <div>
                          <strong>Email:</strong>{" "}
                          {tiles.recentApplication.applicant_id?.email}
                        </div>
                        <div>
                          <strong>Status:</strong>{" "}
                          {tiles.recentApplication.status}
                        </div>
                        <div>
                          <strong>Applied On:</strong>{" "}
                          <Moment format="YYYY-MM-DD HH:mm">
                            {tiles.recentApplication.createdAt}
                          </Moment>
                        </div>
                        <div>
                          <strong>Answers:</strong>
                          <ul>
                            {tiles.recentApplication.answers?.map(
                              (ans, idx) => (
                                <li key={ans._id || idx}>{ans.answersText}</li>
                              )
                            )}
                          </ul>
                        </div>
                        <button
                          className={styles.btn}
                          onClick={() =>
                            navigate(
                              `/research/edit/${tiles.recentApplication.research_id?._id}`
                            )
                          }
                        >
                          View Research
                        </button>
                      </Card.Body>
                    </Card>
                  )}
                </>
              )}
            </div>
          </Col>
          {toggleNotification && (
            <Col md={4} className="p-0">
              <Notification />
            </Col>
          )}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
